'use client';
import { getColorScheme } from '@/utils/getColorScheme';
import { getCTA } from '@/utils/getCTA';
import { getVerticalSpacing } from '@/utils/getVerticalSpacing';
import IconValue from './atoms/IconValue';
import { MarkDown } from './atoms/MarkDown';

export default function SatisfactionGuarantee(props) {
    const {
        Anchor = 'satisfaction-guarantee',
        Icon,
        Header,
        Body,
        ColorScheme = 'primary',
        VerticalSpacing = 'medium',
    } = props;

    const {
        backgroundColor,
        textColor,
        iconColor,
        thirdButton,
        secondaryButton,
        backgroundStyle,
    } = getColorScheme(ColorScheme, props.GradientDirection);
    const vSpace = getVerticalSpacing(VerticalSpacing);
    const { hasAny: hasCTAs, element: CTAs } = getCTA(props, {
        secondaryVariant: secondaryButton,
        outlineVariant: thirdButton,
        wrapSpacing: 'relative z-40 mt-10 lg:mt-16',
        buttonAlign: 'justify-center',
        buttonsClassName:
            'flex max-w-4xl flex-wrap items-center justify-center gap-4',
        className: '',
        size: 'md',
        primaryButtonProps: { className: 'text-center' },
        secondaryButtonProps: { className: 'text-center' },
        outlineButtonProps: { className: 'text-center' },
    });

    return (
        <section
            id={Anchor}
            className={`editable-component relative ${backgroundColor} px-6 lg:px-8 ${vSpace}`}
            style={backgroundStyle}
            data-json="satisfactionguarantee"
        >
            <div className="relative z-40 mx-auto flex max-w-2xl flex-col items-center text-center lg:max-w-4xl">
                <IconValue
                    value={Icon}
                    className={`mx-1 mb-6 text-4xl ${iconColor} sm:text-4xl lg:text-6xl`}
                />
                <MarkDown
                    variant="h2"
                    className={`font-display text-2xl tracking-tight md:text-3xl lg:text-4xl ${iconColor}`}
                >
                    {Header}
                </MarkDown>
                <MarkDown
                    className={`mt-6 text-lg font-text leading-8 ${textColor}`}
                >
                    {Body}
                </MarkDown>
            </div>
            {/* CTA Buttons */}
            <div className="flex w-full justify-center">{hasCTAs && CTAs}</div>
        </section>
    );
}
